module.exports = __webpack_public_path__ + "img/warning-icon.7347b666.svg";